// extracted by mini-css-extract-plugin
module.exports = {"root":"PathAnalyticsView_root__361K0","bigPicture":"PathAnalyticsView_bigPicture__3Zyqr","analytics":"PathAnalyticsView_analytics__2gFkn"};